import Swiper from 'swiper';
import {Autoplay, EffectFade} from 'swiper/modules';

document.addEventListener('DOMContentLoaded', () => {
  const swiper = new Swiper('.slideshow', {
    modules: [Autoplay, EffectFade],
    effect: 'fade',
    autoplay: {
      delay: 4000,
    },
    slidesPerView: 1,
    centeredSlides: true,
    loop: true,
    fadeEffect: {
      crossFade: true,
    },
  });
});
